/* gallery drag v3.1 - scroll freeze */
/* Petal Green – Product Landing Purple
 * Behaviour: gallery, pack selection, addon toggle, accordions, stat ring reveal + count-up.
 *
 * Pack/addon/accordion handlers use event delegation so they keep working
 * even when Shopify's theme editor re-renders blocks. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var page = document.querySelector('.petal-page');
    if (!page) return;

    /* ---------- Pack selection (event-delegated) ---------- */
    page.addEventListener('click', function (e) {
      // Don't change pack selection when the click was on the addon checkbox.
      if (e.target.closest('.petal-addon-check')) return;
      var pack = e.target.closest('.petal-pack');
      if (!pack || !page.contains(pack)) return;
      page.querySelectorAll('.petal-pack').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      pack.classList.add('is-selected');
      setTimeout(function () { try { pack.blur(); } catch (e) {} }, 0);
    });

    page.addEventListener('touchend', function (e) {
      var hit = e.target.closest('.petal-pack, .petal-accordion button, .petal-faq__question, .petal-atc, .petal-small-button, .petal-gallery__nav, .petal-belief__videobtn');
      if (!hit) return;
      setTimeout(function () { try { hit.blur(); } catch (err) {} }, 0);
    }, { passive: true });

    /* ---------- Addon checkbox (event-delegated) ---------- */
    function toggleAddon(el) {
      var checked = el.getAttribute('aria-checked') === 'true';
      el.setAttribute('aria-checked', checked ? 'false' : 'true');
      el.classList.toggle('is-checked');
    }
    page.addEventListener('click', function (e) {
      var el = e.target.closest('.petal-addon-check');
      if (!el || !page.contains(el)) return;
      e.stopPropagation();
      toggleAddon(el);
    });
    page.addEventListener('keydown', function (e) {
      var el = e.target.closest('.petal-addon-check');
      if (!el) return;
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        toggleAddon(el);
      }
    });

    /* ---------- Add to Cart ----------
       The selected pack carries a comma-separated list of variant IDs in
       data-petal-pack-variants. Any addons inside that pack with .is-checked
       contribute their data-addon-variant-id too. We POST all of them at once
       to /cart/add.js (Shopify's "items" array form), then dispatch a
       petal:cart:open event so the cart drawer shows itself with the new lines. */
    var atcBtn = page.querySelector('[data-petal-add-to-cart]');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        var pack = page.querySelector('.petal-pack.is-selected') || page.querySelector('.petal-pack');
        if (!pack) return;

        // Collect IDs: pack variants + checked addons inside the pack.
        // Also collect any discount codes from FREE addons so we can auto-apply
        // them after the cart-add succeeds.
        var ids = [];
        var discountCodes = [];
        var packVariants = (pack.getAttribute('data-petal-pack-variants') || '').split(',');
        packVariants.forEach(function (v) {
          v = (v || '').trim();
          if (v) ids.push(v);
        });
        pack.querySelectorAll('.petal-addon-check.is-checked').forEach(function (addon) {
          var v = (addon.getAttribute('data-addon-variant-id') || '').trim();
          if (v) ids.push(v);
          var code = (addon.getAttribute('data-addon-discount-code') || '').trim();
          var isFree = addon.getAttribute('data-addon-free') === '1';
          if (isFree && code && discountCodes.indexOf(code) === -1) {
            discountCodes.push(code);
          }
        });

        // Pack-level discount code: applied whenever the selected pack carries
        // one. FREE-partner packs use it to zero the free item; discounted
        // bundles (e.g. the Sweet Spot Bundle) use it to apply the bundle % so
        // checkout matches the discounted per-product prices shown on the pack.
        var packCode = (pack.getAttribute('data-pack-discount-code') || '').trim();
        if (packCode && discountCodes.indexOf(packCode) === -1) {
          discountCodes.push(packCode);
        }

        // Deduplicate while collapsing repeats into quantity entries. No line
        // item properties — that would break Shopify's natural merge of the
        // same variant added twice into a single line at qty=2. Instead we
        // track insertion order client-side in sessionStorage (see below).
        var qtyByVariant = {};
        ids.forEach(function (v) {
          qtyByVariant[v] = (qtyByVariant[v] || 0) + 1;
        });
        var items = Object.keys(qtyByVariant).map(function (v) {
          return { id: parseInt(v, 10), quantity: qtyByVariant[v] };
        });

        // Record per-variant insertion order in sessionStorage so the cart
        // drawer can render in stable add-time order even when Shopify shifts
        // line indices around (e.g., addon-already-in-cart bumping). New
        // variants get a new sequence number; existing entries keep theirs.
        try {
          var orderMap = {};
          try { orderMap = JSON.parse(sessionStorage.getItem('petal_cart_order') || '{}') || {}; } catch (e) {}
          var maxSeq = 0;
          for (var k in orderMap) { if (orderMap[k] > maxSeq) maxSeq = orderMap[k]; }
          ids.forEach(function (v) {
            if (orderMap[v] === undefined) {
              maxSeq += 1;
              orderMap[v] = maxSeq;
            }
          });
          sessionStorage.setItem('petal_cart_order', JSON.stringify(orderMap));
        } catch (e) {}
        if (!items.length) {
          console.warn('[petal] No variant IDs available on selected pack — check the section settings.');
          return;
        }

        var originalLabel = atcBtn.textContent;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          atcBtn.disabled = false;
          atcBtn.textContent = originalLabel;
          if (!res.ok) {
            console.warn('[petal] /cart/add.js failed', res.data);
            atcBtn.textContent = (res.data && res.data.description) || 'Couldn’t add — try again';
            setTimeout(function () { atcBtn.textContent = originalLabel; }, 2400);
            return;
          }
          // Stash the codes synchronously so the cart drawer can re-apply
          // them on subsequent visits. Stored as a comma-separated list.
          try {
            var existing = (sessionStorage.getItem('petal_discount_codes') || '').split(',').filter(Boolean);
            discountCodes.forEach(function (c) {
              if (existing.indexOf(c) === -1) existing.push(c);
            });
            sessionStorage.setItem('petal_discount_codes', existing.join(','));
          } catch (e) {}

          // Open the cart drawer immediately on a successful add. We do NOT
          // wait for the discount-code cookies to be set — that work runs in
          // the background below and the cookie will be in place well before
          // the customer hits checkout. Blocking the drawer-open on a 302
          // round-trip per code was adding ~1.5s of perceived latency on the
          // bundle pack (the only one with FREE addons).
          document.dispatchEvent(new CustomEvent('petal:cart:open'));

          // Background: auto-apply any discount codes attached to FREE addons
          // via a hidden iframe. /discount/CODE 302s and sets the cookie on
          // that response. fetch() with redirect:'manual' is flaky for cookie
          // setting in modern browsers, so iframe is the reliable path.
          function applyOne(code) {
            return new Promise(function (resolve) {
              var iframe = document.createElement('iframe');
              iframe.setAttribute('aria-hidden', 'true');
              iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
              var done = false;
              function finish() {
                if (done) return;
                done = true;
                try { iframe.parentNode && iframe.parentNode.removeChild(iframe); } catch (e) {}
                resolve();
              }
              iframe.addEventListener('load', finish);
              // 600ms is enough for a 302 + tiny cart-page render in an iframe.
              // Acts only as a safety net since the drawer is no longer waiting.
              setTimeout(finish, 600);
              iframe.src = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart?petal_applied=' + code);
              document.body.appendChild(iframe);
            });
          }
          var applyChain = Promise.resolve();
          discountCodes.forEach(function (code) {
            applyChain = applyChain.then(function () { return applyOne(code); });
          });
        })
        .catch(function (err) {
          atcBtn.disabled = false;
          atcBtn.textContent = originalLabel;
          console.warn('[petal] cart add error', err);
        });
      });
    }

    /* ---------- Accordions (event-delegated, smooth max-height anim) ----------
       Open: measure scrollHeight, pin as inline max-height. Leave it pinned —
       clearing it would fall back to the base CSS max-height: 0 and trigger a
       second transition that retracts the body and clips the text.
       Close: re-pin current scrollHeight, force reflow, animate back to 0. */
    page.addEventListener('click', function (e) {
      var btn = e.target.closest('.petal-accordion button');
      if (!btn) return;
      var acc = btn.closest('.petal-accordion');
      if (!acc) return;
      var body = acc.querySelector('.petal-accordion__body');
      if (!body) return;
      var isOpen = acc.classList.contains('is-open');
      if (isOpen) {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.offsetHeight; // commit so the next change animates
        body.style.maxHeight = '0px';
        acc.classList.remove('is-open');
      } else {
        acc.classList.add('is-open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });

    /* ---------- Gallery thumbs + arrows (filmstrip slide) ----------
       The track holds the current image. For an arrow click we insert the
       incoming image next to it (right for "next", left for "prev"), then
       translate the whole track so both images move together as one unit.
       After the transition we drop the old image and reset the track to 0.
       Boundaries: prev disabled at index 0, next disabled at last index. */
    var track = page.querySelector('[data-petal-track]');
    var mainImage = page.querySelector('[data-petal-main-image]');
    var prevBtn = page.querySelector('[data-petal-gallery-prev]');
    var nextBtn = page.querySelector('[data-petal-gallery-next]');
    var slideLock = false;
    var SLIDE_MS = 450;

    function petalGetThumbs() {
      return page.querySelectorAll('[data-petal-gallery-thumb]');
    }

    function petalActiveIndex() {
      var thumbs = petalGetThumbs();
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    // Preload the immediate next/prev slide images so navigating the gallery
    // is instant (no blank while a heavier slide — e.g. a demo GIF — downloads).
    // Deduped, and walks ahead as the user browses (each new active slide
    // preloads its own neighbors).
    var petalPreloaded = {};
    function petalPreloadNeighbors() {
      var thumbs = petalGetThumbs();
      if (!thumbs.length) return;
      var idx = petalActiveIndex();
      [idx - 1, idx + 1].forEach(function (i) {
        if (i < 0 || i >= thumbs.length) return;
        var url = thumbs[i].dataset.petalImage;
        if (!url || petalPreloaded[url]) return;
        petalPreloaded[url] = true;
        var im = new Image();
        im.src = url;
      });
    }

    function petalUpdateArrowState() {
      var thumbs = petalGetThumbs();
      if (!thumbs.length) return;
      var idx = petalActiveIndex();
      if (prevBtn) prevBtn.setAttribute('aria-disabled', idx <= 0 ? 'true' : 'false');
      if (nextBtn) nextBtn.setAttribute('aria-disabled', idx >= thumbs.length - 1 ? 'true' : 'false');
    }

    function petalSetActiveThumb(target) {
      petalGetThumbs().forEach(function (item) {
        item.classList.remove('is-active');
        item.removeAttribute('aria-current');
      });
      if (target) {
        target.classList.add('is-active');
        target.setAttribute('aria-current', 'true');
      }
      petalUpdateArrowState();
      petalPreloadNeighbors();
    }

    function petalInstantSwap(thumb) {
      if (!thumb || !mainImage || !thumb.dataset.petalImage) return;
      var url = thumb.dataset.petalImage;
      function apply() {
        // The initial main image carries srcset/sizes, which override .src —
        // without removing them the swap silently does nothing.
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = url;
        mainImage.alt = thumb.dataset.petalAlt || mainImage.alt;
        petalSetActiveThumb(thumb);
      }
      // Decode the new bitmap off-screen first, then swap — avoids the blank
      // flash of assigning .src to the visible img before it has painted.
      var pre = new Image();
      pre.src = url;
      if (pre.decode) { pre.decode().then(apply).catch(apply); } else { apply(); }
    }

    function petalSlideTo(thumb, direction) {
      if (!thumb || !mainImage || !track || !thumb.dataset.petalImage) return;
      if (slideLock) return;
      slideLock = true;

      var incoming = document.createElement('img');
      incoming.className = 'petal-gallery__photo';
      incoming.src = thumb.dataset.petalImage;
      incoming.alt = thumb.dataset.petalAlt || mainImage.alt;
      incoming.loading = 'eager';

      function start() {
        // Position the incoming image in the track on the side it's coming from.
        // Then animate the track so current + incoming drift together.
        track.style.transition = 'none';
        if (direction > 0) {
          track.appendChild(incoming);                 // [current, incoming]
          track.style.transform = 'translateX(0)';
        } else {
          track.insertBefore(incoming, mainImage);     // [incoming, current]
          track.style.transform = 'translateX(-100%)'; // start with current visible
        }
        // Force reflow so the starting transform is committed before we transition
        void track.offsetWidth;

        track.style.transition = 'transform ' + SLIDE_MS + 'ms cubic-bezier(.22, .61, .36, 1)';
        track.style.transform = direction > 0 ? 'translateX(-100%)' : 'translateX(0)';

        track.addEventListener('transitionend', onEnd);
        // Safety net in case transitionend doesn't fire (e.g. tab inactive)
        setTimeout(function () { if (slideLock) finish(); }, SLIDE_MS + 80);
      }

      function finish() {
        track.removeEventListener('transitionend', onEnd);
        // Drop the outgoing image, reset the track to 0 with no transition,
        // and promote the incoming image to be the new "main".
        mainImage.parentNode && mainImage.parentNode.removeChild(mainImage);
        track.style.transition = 'none';
        track.style.transform = 'translateX(0)';
        incoming.setAttribute('data-petal-main-image', '');
        mainImage = incoming;
        petalSetActiveThumb(thumb);
        slideLock = false;
      }
      function onEnd(ev) {
        if (ev.propertyName !== 'transform') return;
        finish();
      }

      // Decode the incoming bitmap before sliding so it never animates a blank
      // panel. startOnce + the timeout guard ensure a stalled/rejected decode
      // can't deadlock the slider (slideLock would otherwise stay true).
      var started = false;
      function startOnce() { if (started) return; started = true; start(); }
      if (incoming.decode) {
        incoming.decode().then(startOnce).catch(startOnce);
        setTimeout(startOnce, 350);
      } else {
        startOnce();
      }
    }

    page.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-petal-gallery-thumb]');
      if (thumb) { petalInstantSwap(thumb); return; }

      var prevHit = e.target.closest('[data-petal-gallery-prev]');
      var nextHit = e.target.closest('[data-petal-gallery-next]');
      if (!prevHit && !nextHit) return;
      e.preventDefault();

      var btn = prevHit || nextHit;
      if (btn.getAttribute('aria-disabled') === 'true') return;

      var thumbs = petalGetThumbs();
      if (!thumbs.length) return;
      var idx = petalActiveIndex();
      var direction = nextHit ? 1 : -1;
      var targetIdx = idx + direction;
      if (targetIdx < 0 || targetIdx >= thumbs.length) return; // hard boundary
      petalSlideTo(thumbs[targetIdx], direction);
    });

    /* ---------- Drag/swipe on the main gallery (touch + mouse) ----------
       The image follows the finger/cursor 1:1 with rubber-band resistance
       past the ends; release past 20% width (or a fast flick) advances.
       Touch is driven by raw touch events so that once a drag locks in as
       horizontal, every following touchmove is preventDefault()ed — that
       freezes page scrolling for the rest of the gesture, so an imperfect
       (slightly diagonal) swipe can no longer scroll the page and break the
       drag. Gestures that START vertical-leaning are handed to the page
       immediately and scroll natively. Mouse/pen drags use pointer events. */
    var galleryMain = page.querySelector('.petal-gallery__main');
    if (galleryMain && track) {
      var drag = null;

      galleryMain.addEventListener('dragstart', function (e) { e.preventDefault(); });

      function petalMakeNeighbor(thumb) {
        if (!thumb || !thumb.dataset.petalImage) return null;
        var img = document.createElement('img');
        img.className = 'petal-gallery__photo';
        img.src = thumb.dataset.petalImage;
        img.alt = thumb.dataset.petalAlt || '';
        img.loading = 'eager';
        img.draggable = false;
        return img;
      }

      function petalDragStart(x, y) {
        if (slideLock || drag) return;
        if (petalGetThumbs().length < 2) return;
        drag = {
          startX: x, startY: y,
          width: galleryMain.clientWidth || 1,
          locked: false, base: 0, delta: 0,
          lastX: x, lastT: 0, vel: 0,
          idx: petalActiveIndex(),
          prevImg: null, nextImg: null, prevThumb: null, nextThumb: null,
          onEnd: null, pointerId: null
        };
      }

      function petalDragLock() {
        var cur = drag;
        if (!cur || cur.locked) return;
        cur.locked = true;
        slideLock = true;
        galleryMain.classList.add('is-dragging');
        var thumbs = petalGetThumbs();
        cur.prevThumb = cur.idx > 0 ? thumbs[cur.idx - 1] : null;
        cur.nextThumb = cur.idx < thumbs.length - 1 ? thumbs[cur.idx + 1] : null;
        cur.prevImg = petalMakeNeighbor(cur.prevThumb);
        cur.nextImg = petalMakeNeighbor(cur.nextThumb);
        track.style.transition = 'none';
        if (cur.prevImg) { track.insertBefore(cur.prevImg, mainImage); cur.base = -cur.width; }
        if (cur.nextImg) track.appendChild(cur.nextImg);
        track.style.transform = 'translateX(' + cur.base + 'px)';
      }

      function petalDragMove(x, t) {
        var cur = drag;
        if (!cur || !cur.locked) return;
        var d = x - cur.startX;
        if ((d > 0 && !cur.prevImg) || (d < 0 && !cur.nextImg)) d = d * 0.3; // rubber band
        cur.delta = d;
        if (cur.lastT && t > cur.lastT) {
          cur.vel = (x - cur.lastX) / (t - cur.lastT);
        }
        cur.lastX = x;
        cur.lastT = t;
        track.style.transform = 'translateX(' + (cur.base + d) + 'px)';
      }

      function petalDragCleanup(cur, promote) {
        if (drag !== cur) return;
        if (cur.onEnd) track.removeEventListener('transitionend', cur.onEnd);
        var promoted = promote === 'next' ? cur.nextImg : promote === 'prev' ? cur.prevImg : null;
        [cur.prevImg, cur.nextImg].forEach(function (img) {
          if (img && img !== promoted && img.parentNode) img.parentNode.removeChild(img);
        });
        if (promoted) {
          if (mainImage.parentNode) mainImage.parentNode.removeChild(mainImage);
          promoted.setAttribute('data-petal-main-image', '');
          mainImage = promoted;
          petalSetActiveThumb(promote === 'next' ? cur.nextThumb : cur.prevThumb);
        }
        track.style.transition = 'none';
        track.style.transform = 'translateX(0)';
        galleryMain.classList.remove('is-dragging');
        slideLock = false;
        drag = null;
      }

      function petalDragRelease(cancelled) {
        var cur = drag;
        if (!cur) return;
        if (!cur.locked) { drag = null; return; }
        var d = cur.delta;
        var goNext = !cancelled && cur.nextImg && (d < -cur.width * 0.2 || (d < -24 && cur.vel < -0.45));
        var goPrev = !cancelled && cur.prevImg && (d > cur.width * 0.2 || (d > 24 && cur.vel > 0.45));
        var promote = goNext ? 'next' : goPrev ? 'prev' : null;
        var target = cur.base + (goNext ? -cur.width : goPrev ? cur.width : 0);

        // A real drag shouldn't also count as a click on whatever it ends over.
        if (Math.abs(d) > 8) {
          var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          galleryMain.addEventListener('click', swallow, true);
          setTimeout(function () { galleryMain.removeEventListener('click', swallow, true); }, 320);
        }

        cur.onEnd = function (ev) {
          if (ev.propertyName !== 'transform') return;
          petalDragCleanup(cur, promote);
        };
        track.addEventListener('transitionend', cur.onEnd);
        track.style.transition = 'transform 260ms cubic-bezier(.22, .61, .36, 1)';
        track.style.transform = 'translateX(' + target + 'px)';
        setTimeout(function () { petalDragCleanup(cur, promote); }, 340);
      }

      /* --- Touch path (non-passive: a locked drag freezes page scroll) --- */
      galleryMain.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { if (drag && !drag.locked) drag = null; return; }
        if (e.target.closest('.petal-gallery__nav')) return;
        petalDragStart(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });

      galleryMain.addEventListener('touchmove', function (e) {
        var cur = drag;
        if (!cur || cur.pointerId !== null) return;
        var t0 = e.touches[0];
        if (!t0) return;
        if (!cur.locked) {
          var dx = t0.clientX - cur.startX;
          var dy = t0.clientY - cur.startY;
          if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }  // vertical intent: let the page scroll
          if (!e.cancelable) { drag = null; return; }                 // browser already scrolling: too late
          if (Math.abs(dx) < 4) return;                               // too early to tell
          petalDragLock();
        }
        if (!e.cancelable) { petalDragRelease(true); return; }
        e.preventDefault(); // gallery owns the gesture — page scroll is frozen
        petalDragMove(t0.clientX, e.timeStamp);
      }, { passive: false });

      galleryMain.addEventListener('touchend', function () {
        if (drag && drag.pointerId === null) petalDragRelease(false);
      }, { passive: true });
      galleryMain.addEventListener('touchcancel', function () {
        if (drag && drag.pointerId === null) petalDragRelease(true);
      }, { passive: true });

      /* --- Mouse / pen path --- */
      galleryMain.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // handled by the touch path
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('.petal-gallery__nav')) return;
        petalDragStart(e.clientX, e.clientY);
        if (drag) drag.pointerId = e.pointerId;
      });
      galleryMain.addEventListener('pointermove', function (e) {
        var cur = drag;
        if (e.pointerType === 'touch' || !cur || cur.pointerId !== e.pointerId) return;
        if (!cur.locked) {
          var dx = e.clientX - cur.startX;
          var dy = e.clientY - cur.startY;
          if (Math.abs(dx) < 6 || Math.abs(dx) <= Math.abs(dy)) {
            if (Math.abs(dy) > 14 && Math.abs(dy) > Math.abs(dx)) drag = null;
            return;
          }
          petalDragLock();
          try { galleryMain.setPointerCapture(e.pointerId); } catch (err) {}
        }
        petalDragMove(e.clientX, e.timeStamp);
      });
      galleryMain.addEventListener('pointerup', function (e) {
        if (e.pointerType === 'touch' || !drag || drag.pointerId !== e.pointerId) return;
        petalDragRelease(false);
      });
      galleryMain.addEventListener('pointercancel', function (e) {
        if (e.pointerType === 'touch' || !drag || drag.pointerId !== e.pointerId) return;
        petalDragRelease(true);
      });
    }

    petalUpdateArrowState();
    petalPreloadNeighbors();

    /* ---------- Thumbnail strip scroll arrows ---------- */
    var thumbStrip = page.querySelector('.petal-gallery__thumbs');
    var thumbArrowL = page.querySelector('.petal-thumb-arrow--left');
    var thumbArrowR = page.querySelector('.petal-thumb-arrow--right');
    if (thumbStrip && thumbArrowL && thumbArrowR) {
      var scrollAmt = function() {
        var thumb = thumbStrip.querySelector('.petal-thumb');
        return thumb ? thumb.offsetWidth + 9 : 100;
      };
      thumbArrowL.addEventListener('click', function() {
        thumbStrip.scrollBy({ left: -scrollAmt() * 2, behavior: 'smooth' });
      });
      thumbArrowR.addEventListener('click', function() {
        thumbStrip.scrollBy({ left: scrollAmt() * 2, behavior: 'smooth' });
      });
    }

    /* ---------- Stats reveal + count-up ----------
       Bell-curve easing (ease-in-out cubic) so the count starts gently, runs
       through the middle, and decelerates into the target — matching the ring
       fill animation's cubic-bezier(.65, 0, .35, 1) timing. */
    function animateCount(el, target, duration, suffix, prefix) {
      suffix = suffix || '';
      prefix = prefix || '';
      var startTime = null;
      function step(t) {
        if (!startTime) startTime = t;
        var p = Math.min((t - startTime) / duration, 1);
        var eased = p < 0.5
          ? 4 * p * p * p
          : 1 - Math.pow(-2 * p + 2, 3) / 2;
        var v = Math.round(target * eased);
        el.textContent = prefix + v + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    /* Each stat card animates independently when it enters the viewport.
       Adding .is-visible to the card both triggers the CSS ring-fill animation
       and runs the count-up. Fixed slow duration (2400ms) — matches the CSS. */
    var STAT_FILL_MS = 2400;

    function fireStatCard(card) {
      if (!card || card.classList.contains('is-visible')) return;
      card.classList.add('is-visible');
      var el = card.querySelector('[data-petal-stat-target]');
      if (!el) return;
      var target = parseFloat(el.getAttribute('data-petal-stat-target')) || 0;
      var suffix = el.getAttribute('data-petal-stat-suffix') || '';
      var prefix = el.getAttribute('data-petal-stat-prefix') || '';
      el.textContent = prefix + '0' + suffix;
      animateCount(el, target, STAT_FILL_MS, suffix, prefix);

      /* Mellowsleep.com-style: set the SVG progress circle's stroke-dashoffset
         inline to the target value. The CSS rule on .petal-stat-ring__progress
         has `transition: stroke-dashoffset 2.4s cubic-bezier(...)`, so the
         browser smoothly tweens between the initial 100 (empty) and the
         target (e.g. 25 for a 75% fill). pathLength=100 is set on the circle
         so values map 1:1 with percentages. */
      var ring = card.querySelector('.petal-stat-ring__progress');
      if (ring) {
        // Force a starting value of 100 and a reflow so the transition picks
        // up the change even if the browser already painted the element.
        ring.style.strokeDashoffset = '100';
        // eslint-disable-next-line no-unused-expressions
        ring.getBoundingClientRect();
        requestAnimationFrame(function () {
          ring.style.strokeDashoffset = String(Math.max(0, 100 - target));
        });
      }
    }

    function observeStatCard(card) {
      if (!card) return;
      // Theme editor: fire immediately so the user can see the animation
      // without scrolling.
      if (window.Shopify && window.Shopify.designMode) {
        fireStatCard(card);
        return;
      }
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            fireStatCard(entry.target);
            obs.unobserve(entry.target);
          });
        }, { threshold: 0.4 });
        observer.observe(card);
      } else {
        fireStatCard(card);
      }
    }

    document.querySelectorAll('.petal-stat-card').forEach(observeStatCard);

    /* Theme editor: re-attach observers when the section reloads (settings
       change) or is selected — the old DOM nodes are replaced. */
    function reinitStats(e) {
      var root = e && e.target && e.target.querySelectorAll ? e.target : document;
      root.querySelectorAll('.petal-stat-card').forEach(observeStatCard);
    }
    document.addEventListener('shopify:section:load', reinitStats);
    document.addEventListener('shopify:section:select', reinitStats);

    /* ---------- Kill hover/transition on pack buttons ----------
       The Debutify base theme sets `transition: opacity .3s, background .3s,
       border .3s, box-shadow .3s` on all <button> elements. On product
       templates the external petal CSS overrides this, but on page templates
       the cascade doesn't always cooperate. This JS fix sets the inline style
       directly so it wins regardless of stylesheet order. */
    function killPackTransitions() {
      page.querySelectorAll('button.petal-pack, button.petal-atc').forEach(function (btn) {
        btn.style.setProperty('transition', 'none', 'important');
        btn.style.setProperty('-webkit-tap-highlight-color', 'transparent');
      });
    }
    killPackTransitions();
    window.addEventListener('load', function () { setTimeout(killPackTransitions, 200); });

    /* ---------- Sticky "Get Yours" CTA ----------
       Reveals the floating CTA once the main Add-to-Cart has scrolled ABOVE the
       viewport (shopper scrolled past the buy box) and hides it again when the
       buy box is back in view. Tapping it smooth-scrolls to the packs (#offer). */
    (function () {
      var bar = page.querySelector('[data-petal-sticky-bar]');
      var link = page.querySelector('[data-petal-sticky-cta]');
      var atc = page.querySelector('[data-petal-add-to-cart]');
      if (!bar || !link || !atc) return;

      // Show the bar once the Add-to-Cart has scrolled fully above the viewport;
      // hide it when back in view. A rAF-throttled scroll check (not Intersection-
      // Observer) is used so a fast/jump scroll that skips over the ATC still
      // toggles correctly. getBoundingClientRect().bottom < 0 = ATC scrolled past.
      var ticking = false;
      function petalStickyUpdate() {
        ticking = false;
        bar.classList.toggle('is-visible', atc.getBoundingClientRect().bottom < 0);
      }
      function petalStickyOnScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(petalStickyUpdate);
      }
      window.addEventListener('scroll', petalStickyOnScroll, { passive: true });
      window.addEventListener('resize', petalStickyOnScroll, { passive: true });
      petalStickyUpdate();

      // Tap = smooth-scroll to whatever the button's href points at (now the
      // "BUY MORE - SAVE MORE" bundle, #bundle). Offset by any sticky header /
      // announcement bar so the bundle title isn't hidden behind it.
      link.addEventListener('click', function (ev) {
        var hash = (link.getAttribute('href') || '').replace(/^#/, '');
        var target = hash ? document.getElementById(hash) : null;
        if (!target) return; // missing target -> let the browser do the default jump
        ev.preventDefault();
        var obstruction = 0;
        ['petal-header', '.petal-header', 'sticky-header', '.header-wrapper', '.petal-announcement--sticky'].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            var cs = window.getComputedStyle(el);
            if (cs.position === 'fixed' || cs.position === 'sticky') {
              var r = el.getBoundingClientRect();
              if (r.top <= 5 && r.bottom > obstruction) obstruction = r.bottom;
            }
          });
        });
        var y = target.getBoundingClientRect().top + window.pageYOffset - obstruction - 16;
        window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
      });
    })();

    /* ---------- Sticky CTA periodic animation ----------
       Replays a chosen motion on the floating "Get Yours" button every N
       seconds (Hero Packs section -> "Sticky CTA - Movement"), but ONLY while
       the bar is on screen (.is-visible). Honors prefers-reduced-motion.
       Re-initializes on Shopify theme-editor events so changing the setting in
       the Customizer updates the live preview without a full reload. */
    var petalCtaAnimTimer = null;
    var petalCtaPrimer = null;
    function setupStickyCtaAnim() {
      if (petalCtaAnimTimer) { clearInterval(petalCtaAnimTimer); petalCtaAnimTimer = null; }
      if (petalCtaPrimer) { clearInterval(petalCtaPrimer); petalCtaPrimer = null; }

      var animPage = document.querySelector('.petal-page');
      if (!animPage) return;
      var animBar = animPage.querySelector('[data-petal-sticky-bar]');
      var cta = animPage.querySelector('[data-petal-sticky-cta]');
      if (!animBar || !cta) return;

      // clear any motion class from a previous init / setting change
      cta.className = cta.className.replace(/\s*petal-cta-anim--\S+/g, '');
      cta.classList.remove('is-anim-playing');

      var anim = (cta.getAttribute('data-petal-cta-anim') || 'none').trim();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!anim || anim === 'none' || reduce) return;

      var secs = parseFloat(cta.getAttribute('data-petal-cta-interval'));
      if (!secs || secs < 2) secs = 2;
      if (secs > 12) secs = 12;

      cta.classList.add('petal-cta-anim--' + anim);
      if (!cta.dataset.petalAnimBound) {
        cta.addEventListener('animationend', function () { cta.classList.remove('is-anim-playing'); });
        cta.dataset.petalAnimBound = '1';
      }

      function play() {
        if (!animBar.classList.contains('is-visible')) return;
        cta.classList.remove('is-anim-playing');
        void cta.offsetWidth; // force reflow so the animation restarts cleanly
        cta.classList.add('is-anim-playing');
      }

      // first play the moment the bar appears, then every N seconds
      var tries = 0;
      petalCtaPrimer = setInterval(function () {
        tries++;
        if (animBar.classList.contains('is-visible')) {
          clearInterval(petalCtaPrimer); petalCtaPrimer = null; play();
        } else if (tries > 120) {
          clearInterval(petalCtaPrimer); petalCtaPrimer = null; // give up after ~42s
        }
      }, 350);
      petalCtaAnimTimer = setInterval(play, secs * 1000);
    }
    setupStickyCtaAnim();
    document.addEventListener('shopify:section:load', setupStickyCtaAnim);
    document.addEventListener('shopify:section:select', setupStickyCtaAnim);
  });
})();
